import dayjs from 'dayjs';
import fileService from '@app/service/fileService';
import { dayFormat } from './format';
import JSZip from 'jszip';

// 다중 이미지 다운로드 시 압축하여 다운로드
export function downloadImagesAsZip(
  imageUrls,
  zipFilename = `OCC_${dayFormat(new Date(), 'YYYY_MM_DD_HHmmss')}`,
) {
  // JSZip 인스턴스 생성
  const zip = new JSZip();

  // 이미지 다운로드 및 압축
  const promises = imageUrls.map((imageUrl, index) => {
    // 이미지를 Blob 형식으로 가져오기
    return fetch(imageUrl)
      .then((response) => response.blob())
      .then((blob) => {
        // Blob을 JSZip에 추가
        zip.file(`${zipFilename}_${index + 1}.jpg`, blob);
      });
  });

  // 모든 이미지 다운로드가 완료되면 압축 파일 생성 및 다운로드
  Promise.all(promises)
    .then(() => {
      // 압축 파일 생성
      return zip.generateAsync({ type: 'blob' });
    })
    .then((blob) => {
      // 압축 파일 다운로드
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = zipFilename || 'images.zip';
      link.click();
    });
}
// 다중 파일 다운로드 시 압축하여 다운로드 (확장자 때문에 fileName이 있을 때 사용)
export function downloadFilesAsZip(
  files = [{ fileUrl: null, fileName: null }],
  zipFilename = `OCC_${dayFormat(new Date(), 'YYYY_MM_DD_HHmmss')}`,
) {
  // JSZip 인스턴스 생성
  const zip = new JSZip();

  // 이미지 다운로드 및 압축
  const promises = files.map((file, index) => {
    if (!file.fileUrl) return null;
    // 이미지를 Blob 형식으로 가져오기
    return fetch(file.fileUrl)
      .then((response) => response.blob())
      .then((blob) => {
        // Blob을 JSZip에 추가
        zip.file(file.fileName, blob);
      });
  });
  // 모든 이미지 다운로드가 완료되면 압축 파일 생성 및 다운로드
  Promise.all(promises)
    .then(() => {
      // 압축 파일 생성
      return zip.generateAsync({ type: 'blob' });
    })
    .then((blob) => {
      // 압축 파일 다운로드
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = zipFilename || 'images.zip';
      link.click();
    });
}
export function downloadFile(
  fileUrl,
  fileName = `OCC_${dayFormat(new Date(), 'YYYY_MM_DD_HHmmss')}`,
) {
  fileService.downloadFile(fileUrl).then((res) => {
    const blob = new Blob([res.data]);
    const url = window.URL.createObjectURL(blob);

    //확장자명 찾기 (요청Url에서 마지막 단어 : .xml, .jpg 등등)
    const requestUrl = res.request.responseURL;
    const fileExtension = requestUrl.split('.').pop();

    let link = document.createElement('a');
    document.body.appendChild(link);
    link.setAttribute('download', `${fileName}.${fileExtension}`);
    link.style.display = 'none';
    link.setAttribute('href', url);
    link.click();
    document.body.removeChild(link);
  });
}

//파일 업로드
export function uploadFile(fileList, thumbnail) {
  console.log('fileList : ', fileList);
  return new Promise(async (resolve, reject) => {
    //  파일 목록에서 originalFile 값 없으면 업로드하지않고 return
    const originalValues = [];
    const uploadFiles = [];
    try {
      fileList.forEach((file) => {
        if (file.originFileObj) {
          //   formData.append("files", file?.originFileObj);
          uploadFiles.push(file);
        } else {
          originalValues.push(file);
        }
      });
      let responseUrls = [];
      if (uploadFiles?.[0]) {
        const fileProm = await fileService.uploadFile(uploadFiles, {
          thumbnail,
        });
        responseUrls = fileProm?.data?.data;
      }
      resolve([...originalValues, ...responseUrls]);
    } catch (e) {
      reject(e);
      console.log(e);
    }
  });
}

//파일 다운로드
export function fileDownload(url, filename, isCsv) {
  const link = document.createElement('a');
  link.href = url;
  link.style.display = 'none';
  link.setAttribute('download', filename);

  document.body.appendChild(link);
  link.click();

  setTimeout(() => {
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }, 200);
}

//url로 파일 다운로드
// 반환값: { ok: true } 성공, { ok: false, error } 실패. 기존 호출부는 반환값을 쓰지 않아도 된다.
export function downloadUrl(url, filename, isCsv, setLoading, noneUrlType) {
  if (!url) return Promise.resolve({ ok: false, error: new Error('empty url') });
  if (setLoading) setLoading(true);
  return fileService
    .downloadFile(url)
    .then((data) => {
      // url요청 -> blobfile -> createObjectUrl -> 태그 생성 및 클릭
      const blobData = isCsv ? ['\ufeff', data.data] : [data.data];
      const blob = new Blob(blobData, {
        type: 'application/octet-stream',
      });
      const src = window.URL.createObjectURL(blob);
      //확장자명 찾기 (요청Url에서 마지막 단어 : .xml, .jpg 등등)
      const requestUrl = data.request.responseURL;
      const lastIndex = requestUrl.lastIndexOf('.');
      const type = requestUrl.substr(lastIndex);

      const url = { src: src, type: type };
      let link = document.createElement('a');
      document.body.appendChild(link);
      const name = noneUrlType
        ? filename || 'OCC_파일_다운로드' + dayjs().format('YYYYMMDDhhmmss')
        : (filename || 'OCC_파일_다운로드' + dayjs().format('YYYYMMDDhhmmss')) +
          url.type;

      link.setAttribute('download', name);
      link.style.display = 'none';
      link.setAttribute('href', url.src);
      link.click();
      document.body.removeChild(link);
      return { ok: true };
    })
    .catch((e) => {
      // 실패 원인은 콘솔에 남기고, 화면 안내는 호출부가 반환값으로 처리한다.
      console.log('file download error', e);
      return { ok: false, error: e };
    })
    .finally(() => setLoading && setLoading(false));
}
// blob 파일 다운로드 (엑셀 포멧, 엑셀 다운로드)
export function blobFileDownload(data, filename, isCsv) {
  /**
   * isCsv : csv 파일 여부
   * csv는 '\ufeff' 를 붙여야 한글이 깨지지 않음
   * */
  const blobData = isCsv ? ['\ufeff', data] : [data];
  const blob = new Blob(blobData, { type: 'application/octet-stream' });

  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.style.display = 'none';
  link.setAttribute('download', filename);

  document.body.appendChild(link);
  link.click();

  setTimeout(() => {
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }, 200);
}

export const removeFilenameExt = (filename) =>
  filename?.split('.')?.[0] || filename;
